import { BookableDetail, BookableUpsertPayload } from "@/types/bookable";

import { requestData } from "@/api/api-config";

export async function listBookables(): Promise<BookableDetail[] | null> {
  return await requestData<BookableDetail[]>("admin/bookables/list", "get");
}

export async function updateOrCreateBookable(
  bookable: BookableUpsertPayload,
): Promise<BookableDetail | null> {
  return await requestData<BookableDetail>(
    "admin/bookables/update-or-create",
    "post",
    { json: bookable },
    /* catchError */ false,
  );
}

export async function deleteBookable(
  bookableId: string,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `admin/bookables/delete/${bookableId}`,
    "delete",
  );
}
